export default __webpack_public_path__ + "static/prologue-e2ab5f5699cfb5944b14ebdf8be0b38b.svg";